import { Typography } from '@mui/material';

export default function Eyebrow({ children, component = 'p', sx }) {
    return (
        <Typography variant="subtitle2" component={component} sx={sx}>
            {children}
        </Typography>
    );
}
